var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "block-relative" },
    [
      _c("router-view"),
      _vm.loading
        ? _c(
            "div",
            {
              staticClass: "loader block__absolute flex-box",
              staticStyle: { position: "fixed" },
            },
            [_vm._m(0)]
          )
        : _vm._e(),
      _c("portal-target", { attrs: { name: "sidebar", multiple: "" } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon text-white flex-box" }, [
      _c("i", { staticClass: "fas fa-spinner fa-spin" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }